export class ConfigurationPaths {
    public static audit: string = 'configuration/audit';
    public static file: string = 'configuration/file';
    public static configuration: string = 'configuration/configuration';
}
